import './prontuario.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import Lupa from '../../assets/icons/lupa.svg';
import { useEffect, useState } from 'react';
import { useProntuario } from '../../context/prontuariocontext';

const PesquisaProntuario = () => {
  const { results, loading, error, searchProntuario, downloadProntuario, setResults } = useProntuario();
  const [term, setTerm] = useState('');
  const [hasSearched, setHasSearched] = useState(false);

  const executeSearch = async () => {
    if (!term.trim()) return;
    await searchProntuario(term);
    setHasSearched(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await executeSearch();
  };

  const handleClear = () => {
    setTerm('');
    setHasSearched(false);
    if (setResults) setResults([]);
  };

  useEffect(() => {
    if (term.trim() !== '') return;
    if (!hasSearched && results.length === 0) return;

    setHasSearched(false);
    if (setResults) setResults([]);
  }, [term, hasSearched, results.length, setResults]);

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container'>
        <h4 className='h4-title'>Pesquisar Prontuário</h4>

        <Titulo
          children={
            <div className="search-container">
              <form className="search-form" onSubmit={handleSubmit}>
                <div className="search-row">
                  <div className="search-wrapper">
                    <input
                      placeholder='Digite sua busca aqui'
                      value={term}
                      onChange={(e) => setTerm(e.target.value)}
                    />
                    <img src={Lupa} alt="Lupa" className="search-icon" />
                  </div>
                </div>
              </form>
            </div>
          }
          children2={
            <div className="prontuario-actions-top">
              <button
                className='btn-buscar-prontuario'
                onClick={executeSearch}
                type="button"
                disabled={loading}
              >
                <img src={Lupa} alt="Lupa"/> {loading ? 'Buscando...' : 'Pesquisar'}
              </button>
              <button
                className='btn-buscar-prontuario btn-limpar-prontuario'
                onClick={handleClear}
                type="button"
                disabled={loading || (!term.trim() && results.length === 0)}
              >
                <strong>X</strong> Limpar filtro
              </button>
            </div>
          }
        />

        <div className="prontuario-results">
          {error && <p className="prontuario-error">{error}</p>}
          {!error && results.length === 0 && !loading && (
            <p className="prontuario-empty">Nenhum documento encontrado.</p>
          )}
          {loading && <p className="prontuario-loading">Buscando documentos...</p>}
          {!loading && results.length > 0 && (
            <div className="prontuario-grid">
              {results.map(({ entry }) => (
                <div key={entry.id} className="prontuario-card">
                  <div className="prontuario-card-header">
                    <p className="prontuario-name">{entry.name}</p>
                    <span className="prontuario-mime">{entry.content?.mimeTypeName || entry.nodeType}</span>
                  </div>
                  <div className="prontuario-meta">
                    <p><strong>Tamanho:</strong> {(entry.content?.sizeInBytes || 0).toLocaleString()} bytes</p>
                    <p><strong>Criado por:</strong> {entry.createdByUser?.displayName || entry.createdByUser?.id}</p>
                    <p><strong>Criado em:</strong> {entry.createdAt ? new Date(entry.createdAt).toLocaleString() : '-'}</p>
                  </div>
                  <div className="prontuario-actions">
                    <button
                      type="button"
                      className="btn-download"
                      onClick={() => downloadProntuario(entry.id, entry.name)}
                    >
                      Baixar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>



      </div>
    </div>
  );
};

export default PesquisaProntuario;
